export default "__VITE_ASSET__337f4fde__"